/* eslint-disable jsx-a11y/no-onchange */
import React, { useEffect, useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { endPoints, GA, PLATFORM } from '../../../constants'
import { UserDetailsWrapper, Heading } from './styles'
import { setWindowGA } from '../../../helpers/DTM'
import {
	UserInfoType,
	ViewTypes,
	APIMethods,
	ReqBodyWithHeaders,
} from '../../../types/state'
import { useDispatch, useSelector } from 'react-redux'
import { updateStep } from '../../../redux/slices/meta'
import { RootState } from '../../../redux/store'
import FormInput from '../../../components/FormInput'
import WrapperButton from '../../../components/WrapperButton'
import { saveLeads } from '../../../redux/slices/user'
import { useTransition, animated } from 'react-spring'
import {
	InputTypes,
	LeadFormErrorTypes,
	LeadFormTypes,
} from '../../../types/components'
import City from './Address/City'
import State from './Address/State'
import RadioInput from './RadioInputGroup'
import { loadTranslations } from '../../../redux/slices/translation'

const UserDetails = () => {
	const dispatch = useDispatch()
	const [isLoaded, setIsLoaded] = useState(false)

	const transition = useTransition(isLoaded, {
		from: { opacity: 0, transform: 'translateX(-20px)', delay: 100 },
		enter: { opacity: 1, transform: 'translateX(0)', delay: 100 },
		leave: { opacity: 0, transform: 'translateX(20px)', delay: 100 },
	})
	useEffect(() => {
		setIsLoaded(true)
		const listener = () => {
			const userAgent = navigator.userAgent.toLowerCase()
			const Android = userAgent.indexOf('android') > -1
			if (Android) {
				window.scrollTo(0, document.body.scrollHeight)
			} else {
				document.body.style.margin = '0'
			}
		}
		window?.visualViewport?.addEventListener('resize', listener)
	}, [])

	const userDetails = useSelector((state: RootState) => state.user)
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	const [formValues, setFormValues] = useState<LeadFormTypes>({
		regionalLanguageProficiency: '',
		name: '',
		email: '',
		dob: '',
		pincode: '',
		gender: '',
		education: '',
		city: '',
		state: '',
	})
	const [errors, setError] = useState<LeadFormErrorTypes>({
		name: undefined,
		email: undefined,
		dob: undefined,
		pincode: undefined,
		gender: undefined,
		education: undefined,
		city: undefined,
		state: undefined,
	})

	useEffect(() => {
		const data = {
			event: GA.eventName,
			pageName: GA.namePage,
			mobile: btoa(userDetails.phone.toString()),
			pageURL: window.location.href + '/userInfo',
			customerID: userDetails.id,
			lkUserType: userDetails.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		setWindowGA(data)
	}, [metaData.isLogin, metaData.platform, userDetails])

	const handleForm = (e: React.ChangeEvent<HTMLInputElement>) => {
		const event = e.target as HTMLButtonElement
		setFormValues({ ...formValues, [event.name]: event.value })
		setError({ ...errors, [event.name]: undefined })
	}

	const handleRadioAction = (
		field: string,
		e: React.ChangeEvent<HTMLInputElement>,
		step: UserInfoType
	) => {
		const event = e.target as HTMLButtonElement
		setFormValues({ ...formValues, [field]: event.value })
		setError({ ...errors, [field]: undefined })
		if (event.name === UserInfoType.REGINAL_LANGUAGE_PROFICIENCY) {
			dispatch(
				loadTranslations({
					language: event.value === 'true',
				})
			)
		}
		const currentView = metaData.userInfoStep
		if (handleValidation(currentView)) {
			dispatch(updateStep(step))
		}
	}

	const handleState = (step: UserInfoType) => {
		const currentView = metaData.userInfoStep
		if (handleValidation(currentView)) {
			dispatch(updateStep(step))
		}
	}

	const handleDob = (dateString: any) => {
		const dateParts = dateString.split('/')

		const dateObject = new Date(
			+dateParts[2],
			dateParts[1] - 1,
			+dateParts[0]
		)
		return dateObject
	}

	const handleSubmit = () => {
		//CT
		window.clevertap.onUserLogin.push({
			Site: {
				Name: formValues.name, //khc
				Identity: userDetails.phone,
				Email: formValues.email,
				Phone: `+91${userDetails.phone}`,
				Gender: formValues.gender === 'male' ? 'M' : 'F', //khc
				DOB: handleDob(formValues.dob),
				'MSG-email': true,
				'MSG-push': true,
				'MSG-sms': true,
				'MSG-whatsapp': true,
			},
		})
		window.clevertap.profile.push({
			Site: {
				// 'LSPKHC DOB': formValues.dob,
				'LSPKHC Leads': 'true',
				// 'LSPKHC Name': formValues.name,
				'LSPKHC City': formValues.city,
				// 'LSPKHC Gender': formValues.gender,
			},
		})
		window.clevertap.event.push('Pages Viewed', {
			'Page Name': GA.addressPage,
			Phone: userDetails.phone,
		})
		//GA
		const data = {
			event: GA.eventName,
			pageName: GA.addressPage,
			mobile: btoa(userDetails.phone.toString()),
			pageURL: window.location.href + 'user_info',
			customerID: userDetails.id,
			lkUserType: userDetails.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		setWindowGA(data)
		const obj: ReqBodyWithHeaders = {
			url: endPoints.leads,
			method: APIMethods.POST,
			client: metaData.deviceType,
			sessionId: userDetails.sessionId,
			platformName: PLATFORM,
			fullName: formValues.name,
			phoneNumber: `+91${userDetails.phone}`,
			gender: formValues.gender,
			dateOfBirth: formValues.dob,
			address: formValues.city,
			regionalLanguageProficiency:
				formValues.regionalLanguageProficiency === 'true',
			education: formValues.education,
			state: formValues.state,
			email: formValues.email,
		}
		dispatch(saveLeads(obj))
	}

	const validateEmail = (email: string) => {
		const re = /\S+@\S+\.\S+/
		return re.test(email)
	}

	const validateTextOnly = (text: string) => {
		const re = /^[a-zA-Z ]*$/
		return re.test(text)
	}

	const validateDate = (text: string) => {
		const replacedSlash = text.replace(/\//g, '')
		const re = /^[0-9]*$/
		// return re.test(replacedSlash)
		if (re.test(replacedSlash)) {
			return validateDDMMYYYY(text)
		} else {
			return false
		}
	}

	const validateDDMMYYYY = (text: string) => {
		const initial = text.split(/\//)
		const dd = initial[0]
		const mm = initial[1]
		const yyyy = initial[2]
		if (dd > '31' || mm > '12' || yyyy < '1921') {
			return false
		} else {
			return true
		}
	}

	const process = (date: string) => {
		const parts = date.split('/')
		const date1 = new Date(parts[1] + '/' + parts[0] + '/' + parts[2])
		return date1.getTime()
	}

	const handleValidation = (name: string) => {
		let formIsValid = true

		//Name validation
		if (name === 'name' || name === 'state') {
			if (!validateTextOnly(formValues.name)) {
				formIsValid = false
				setError((prevError: LeadFormErrorTypes) => {
					return {
						...prevError,
						[name]: `Please enter a valid ${name}`,
					}
				})
			}
		}

		//Email format check
		if (name === 'email') {
			if (!validateEmail(formValues.email)) {
				formIsValid = false
				setError((prevError: LeadFormErrorTypes) => {
					return {
						...prevError,
						email: 'Please enter a valid email.',
					}
				})
			}
		}

		//DOB
		if (name === 'dob') {
			const lastDate = '31/12/2004'
			const inputDate = formValues.dob
			if (!validateDate(inputDate)) {
				formIsValid = false
				setError((prevError: LeadFormErrorTypes) => {
					return {
						...prevError,
						dob: 'Please enter a valid date',
					}
				})
			}
			if (process(inputDate) > process(lastDate)) {
				formIsValid = false
				setError((prevError: LeadFormErrorTypes) => {
					return {
						...prevError,
						dob: 'Minimum participation age is 18 for KHC Marathi',
					}
				})
			}
		}

		return formIsValid
	}

	const onNextButtonClick = (step: UserInfoType) => {
		sendCTGA(step)
		const currentView = metaData.userInfoStep
		if (handleValidation(currentView)) {
			dispatch(updateStep(step))
		}
	}

	const onDOB = (e: any) => {
		const content = e.target.value
		const lastChar = content.substr(content.length - 1)
		const content1 = content.replace(/\//g, '')
		const length = content1.length
		if (e.nativeEvent.inputType === 'insertText') {
			if (content.length <= 10) {
				if (length % 2 == 0 && length < 6 && length > 1) {
					if (lastChar === '/') {
						const final = content.slice(0, -1)
						setFormValues({ ...formValues, dob: final })
						setError({ ...errors, dob: undefined })
					} else {
						const final = content + '/'
						setFormValues({ ...formValues, dob: final })
						setError({ ...errors, dob: undefined })
					}
				} else setFormValues({ ...formValues, dob: content })
			}
		} else {
			const final = content.slice(0, -1)
			setFormValues({ ...formValues, dob: final })
			setError({ ...errors, dob: undefined })
		}
	}

	const updateFormData = (formObj: LeadFormTypes) => {
		formValues.city = formObj.city
		handleSubmit()
	}

	const sendCTGA = (step: UserInfoType) => {
		const data = {
			event: GA.eventName,
			mobile: btoa(userDetails.phone.toString()),
			pageURL: window.location.href + '/userInfo',
			customerID: userDetails.id,
			lkUserType: userDetails.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		if (step === 'email') {
			window.clevertap.event.push('Pages Viewed', {
				'Page Name': GA.namePage,
				Phone: userDetails.phone,
			})
			window.clevertap.event.push('Pages Viewed', {
				'Page Name': GA.emailPage,
				Phone: userDetails.phone,
			})
			const ga = { ...data, pageName: GA.emailPage }
			setWindowGA(ga)
		}
		if (step === 'dob') {
			window.clevertap.event.push('Pages Viewed', {
				'Page Name': GA.dobPage,
				Phone: userDetails.phone,
			})
			const ga = { ...data, pageName: GA.dobPage }
			setWindowGA(ga)
		}
		if (step === 'gender') {
			window.clevertap.event.push('Pages Viewed', {
				'Page Name': GA.genderPage,
				Phone: userDetails.phone,
			})
			const ga = { ...data, pageName: GA.genderPage }
			setWindowGA(ga)
		}
	}
	return (
		<>
			{transition((style, item) =>
				item ? (
					<animated.div style={style}>
						<UserDetailsWrapper device={metaData.deviceType}>
							{metaData.view === ViewTypes.USER_INFO && (
								<>
									{metaData.userInfoStep ===
										UserInfoType.REGINAL_LANGUAGE_PROFICIENCY && (
										<>
											<Heading>
												{translations.REGINAL_LANGUAGE_PROFICIENCY}
											</Heading>
											<RadioInput
												formValues={formValues}
												handleChange={(e) =>
													handleRadioAction(
														UserInfoType.REGINAL_LANGUAGE_PROFICIENCY,
														e,
														UserInfoType.NAME
													)
												}
												options={[
													{
														name: UserInfoType.REGINAL_LANGUAGE_PROFICIENCY,
														value: 'true',
														id: 'yes',
														label: translations.YES,
													},
													{
														name: UserInfoType.REGINAL_LANGUAGE_PROFICIENCY,
														value: 'false',
														id: 'no',
														label: translations.NO,
													},
												]}
											/>
										</>
									)}
									{metaData.userInfoStep === UserInfoType.NAME && (
										<>
											<Heading>{translations.YOUR_NAME}</Heading>
											<FormInput
												type={InputTypes.TEXT}
												label={translations.NAME}
												value={formValues.name}
												name="name"
												handleChange={(e) => handleForm(e)}
												errorMessage={errors.name}
												autofocus={true}
											/>
											<WrapperButton
												isLoading={metaData.isLoading}
												buttonClickHandler={() =>
													onNextButtonClick(UserInfoType.EMAIL)
												}
												isEnabled={
													formValues.name.length > 0 ? true : false
												}
												btnText={translations.CONTINUE}
											/>
										</>
									)}

									{metaData.userInfoStep === UserInfoType.EMAIL && (
										<>
											<Heading>{translations.YOUR_EMAIL}</Heading>
											<FormInput
												type={InputTypes.TEXT}
												label={translations.EMAIL}
												value={formValues.email}
												name="email"
												handleChange={(e) => handleForm(e)}
												errorMessage={errors.email}
												autofocus={true}
											/>
											<WrapperButton
												isLoading={metaData.isLoading}
												buttonClickHandler={() =>
													onNextButtonClick(UserInfoType.DOB)
												}
												isEnabled={
													formValues.email.length > 0
														? true
														: false
												}
												btnText={translations.CONTINUE}
												height="50px"
												width="50%"
											/>
										</>
									)}

									{metaData.userInfoStep === UserInfoType.DOB && (
										<>
											<Heading>{translations.YOUR_DOB}</Heading>
											<FormInput
												type={InputTypes.TEXT}
												label="DD/MM/YYYY"
												value={formValues.dob}
												name="dob"
												handleChange={(e) => onDOB(e)}
												errorMessage={errors.dob}
												pattern="[0-9]*"
												autofocus={true}
												inputmode="numeric"
											/>
											<WrapperButton
												isLoading={metaData.isLoading}
												buttonClickHandler={() =>
													onNextButtonClick(UserInfoType.GENDER)
												}
												isEnabled={
													formValues.dob.length === 10
														? true
														: false
												}
												btnText={translations.CONTINUE}
											/>
										</>
									)}
									{metaData.userInfoStep === UserInfoType.GENDER && (
										<>
											<Heading>{translations.YOUR_GENDER}</Heading>
											<RadioInput
												formValues={formValues}
												handleChange={(e) =>
													handleRadioAction(
														'gender',
														e,
														UserInfoType.EDUCATION
													)
												}
												options={[
													{
														name: 'gender',
														value: 'male',
														id: 'male',
														label: translations.MALE,
													},
													{
														name: 'gender',
														value: 'female',
														id: 'female',
														label: translations.FEMALE,
													},
													{
														name: 'gender',
														value: 'other',
														id: 'other',
														label: translations.GENDER_NOT_SAY,
													},
												]}
											/>
										</>
									)}

									{metaData.userInfoStep ===
										UserInfoType.EDUCATION && (
										<>
											<Heading>
												{translations.YOUR_EDUCATION}
											</Heading>
											<RadioInput
												formValues={formValues}
												handleChange={(e) =>
													handleRadioAction(
														'education',
														e,
														UserInfoType.STATE
													)
												}
												options={[
													{
														name: 'education',
														value: 'graduate',
														id: 'graduate',
														label: translations.GRADUATE,
													},
													{
														name: 'education',
														value: 'non-graduate',
														id: 'non-graduate',
														label: translations.NON_GRADUATE,
													},
												]}
											/>
										</>
									)}

									{metaData.userInfoStep === UserInfoType.STATE && (
										<State
											formValues={formValues}
											errors={errors}
											handleForm={handleForm}
											handleSubmit={() =>
												handleState(UserInfoType.CITY)
											}
										/>
									)}

									{metaData.userInfoStep === UserInfoType.CITY && (
										<City
											formValues={formValues}
											errors={errors}
											handleForm={handleForm}
											handleSubmit={handleSubmit}
											updateFormData={updateFormData}
										/>
									)}
								</>
							)}
						</UserDetailsWrapper>
					</animated.div>
				) : (
					''
				)
			)}
		</>
	)
}

export default UserDetails
